import './styles.scss';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import {} from 'src/validations';
import { IAppState } from 'src/store';
import { View, Button, Text, Checkbox } from 'src/components/common';
import './styles.scss';
import { Modal } from 'src/components/Modal';
import { People } from 'src/dataFactory/depositionFactory';
import { usersActions } from 'src/redux/usersRedux';
import PartyPlaceholder from '../../NewDeposition/AddParties/PartyPlaceholder';
import InvolvedPartiyToAdd from '../../NewDeposition/AddParties/InvolvedParties';

const AddParties: React.FC<Props> = ({ onClose, onSaveData, addedParties = [] }) => {
  const [parties, setParties] = useState<People[]>(addedParties);
  useEffect(() => {
    if (addedParties) setParties(addedParties);
  }, [addedParties]);

  const handleChange = (e: any, user: People) => {
    const checked = e.target.checked;
    const updatedData = parties.map(party =>
      party.id === user.id
        ? {
            ...party,
            canAccessFinalDeposition: checked,
          }
        : party,
    );
    setParties(updatedData);
  };

  const handleSubmitData = () => {
    onSaveData(parties);
  };
  const count = parties.filter(party => party.canAccessFinalDeposition).length;

  return (
    <Modal onModalClosed={onClose} modalContainerClassName={'ctn-add-party'}>
      <Text variant="title">Grant Parties Access to Final Deposition</Text>
      <View className="mt-20 add-parties">
        <View id="scrollableDiv" className={'ctn-add-party__users'}>
          <InfiniteScroll
            dataLength={addedParties.length}
            next={() => {}}
            hasMore={false}
            loader={
              <React.Fragment>
                <PartyPlaceholder />
                <PartyPlaceholder />
                <PartyPlaceholder />
                <PartyPlaceholder />
              </React.Fragment>
            }
            scrollableTarget="scrollableDiv"
            endMessage={null}>
            <View style={{ overflow: 'auto' }}>
              {parties.map(party => (
                <View isRow style={{ flexWrap: 'nowrap' }}>
                  <Checkbox.Item
                    onChange={e => handleChange(e, party)}
                    checked={party.canAccessFinalDeposition}
                    name={party.id + ''}
                  />
                  <InvolvedPartiyToAdd user={party} />
                </View>
              ))}
            </View>
          </InfiniteScroll>
        </View>
        <View isRow justify="flex-end" className="mt-24">
          <Button onClick={onClose} variant="secondary-outline">
            CANCEL
          </Button>
          <Button type="button" onClick={() => handleSubmitData()} variant="secondary" className="ml-20">
            {`ADD ${count} ${count < 2 ? 'PARTY' : 'PARTIES'} `}
          </Button>
        </View>
      </View>
    </Modal>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose: () => void;
    onSaveData: (data: People[]) => void;
    addedParties?: People[];
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  onGetUsers: usersActions.getUsers,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddParties);
